import React, { useState } from 'react';
import './FAQ.css';

// --- Icons ---
const StarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="#C98E32" stroke="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const MinusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const FAQ_DATA = [
  {
    id: 1,
    question: 'How does the doorstep repair service work?',
    answer:
      'Simply select your device and book a service online or via phone/WhatsApp. Our certified technician will arrive at your home or office at your scheduled time with genuine parts and perform the repair right in front of you.',
  },
  {
    id: 2,
    question: 'How long does a repair usually take?',
    answer:
      'Most common repairs—such as screen replacements, battery changes, and charging port fixes—are completed within 30 to 45 minutes at your location.',
  },
  {
    id: 3,
    question: 'Are the replacement parts genuine?',
    answer:
      'Yes, 100%! We use only Grade-A genuine OEM replacement parts backed by up to 1 year of warranty for complete peace of mind.',
  },
  {
    id: 4,
    question: 'Is there any extra charge for doorstep service?',
    answer:
      'No, there are no hidden or extra doorstep visit charges. You only pay for the transparent repair cost quoted before service begins.',
  },
  {
    id: 5,
    question: 'What warranty do you offer on repairs?',
    answer:
      'We provide up to 12 months warranty on screen and hardware replacement parts, covering any manufacturing defects or functional issues.',
  },
  {
    id: 6,
    question: 'Is my data safe during the repair?',
    answer:
      'Absolutely. Since all repairs take place in front of your eyes at your doorstep, your personal data, photos, and files remain completely private and secure.',
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState(1);

  const toggleFaq = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="faq-section" id="faq">
      {/* Background Ambient Ornaments */}
      <div className="faq-bg-dots faq-bg-dots-left" aria-hidden="true" />
      <div className="faq-bg-dots faq-bg-dots-right" aria-hidden="true" />
      <div className="faq-bg-glow" aria-hidden="true" />

      <div className="faq-container">
        {/* Header */}
        <header className="faq-header">
          <div className="faq-badge">
            <StarIcon />
            <span>FREQUENTLY ASKED QUESTIONS</span>
          </div>

          <h2 className="faq-title">
            <span className="faq-title-main">Got Questions?</span>
            <span className="faq-title-gold"> We Have Answers</span>
          </h2>

          {/* Gold Diamond Divider Ornament */}
          <div className="faq-heading-divider" aria-hidden="true">
            <div className="faq-divider-line" />
            <div className="faq-divider-diamond" />
            <div className="faq-divider-line" />
          </div>

          <p className="faq-subtitle">
            Everything you need to know about our doorstep repair service, warranties, and pricing.
          </p>
        </header>

        {/* Accordion Cards List */}
        <div className="faq-list">
          {FAQ_DATA.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`faq-3d-card ${isOpen ? 'faq-card-open' : ''}`}
              >
                <div
                  className="faq-question-bar"
                  onClick={() => toggleFaq(item.id)}
                  role="button"
                  tabIndex={0}
                  aria-expanded={isOpen}
                >
                  <h3 className="faq-question-text">{item.question}</h3>

                  <button className="faq-action-btn" aria-label="Toggle answer">
                    {isOpen ? <MinusIcon /> : <PlusIcon />}
                  </button>
                </div>

                {isOpen && (
                  <div className="faq-answer-body">
                    <p className="faq-answer-text">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
